export default __webpack_public_path__ + "static/media/1030.62ecf6a9.png";